export default __webpack_public_path__ + "static/sanctuary-homepage-banner-1-mobile-a691d6d5045a62089a55d1816274ab9f.webp";